import { Component, Input, OnInit, Output, OnDestroy } from '@angular/core';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { LoaderService } from '../../infrastructure/services/loader.service';
import { AlertService, GrowlType } from '../../infrastructure/services/alert.service';
import { Subscription } from 'rxjs';
import { TipoSolicitud } from 'app/infrastructure/model/interfaces/tiposolicitud.interface';
import { TipoSolicitudService } from 'app/infrastructure/services/tiposolicitud.service';


@Component({
  templateUrl: './configurar.tiposolicitud.component.html',
})

export class ConfigurarTipoSolicitudComponent implements OnInit, OnDestroy {
  @Input('tiposolicitud') tiposolicitud: TipoSolicitud;

  codTipoSolicitud: string;
  esNuevo = true;
  checkeandCodigo = false;
  errorCodigo = null;
  tipoEntidades= ['Poliza', 'Cotizacion'];
  itemscategoriausuaria= ['Usuario', 'Manager'];
  subscripcion: Subscription;

  constructor(public loaderService: LoaderService,
              private alertService: AlertService,
              private tipoSolicitudService: TipoSolicitudService,
              private router: Router,
              private aRoute: ActivatedRoute) { }

  ngOnInit() {
    this.aRoute.params.subscribe((params: Params) => {
      this.codTipoSolicitud = params['codTipoSolicitud'];

      this.esNuevo = false;

      if (this.codTipoSolicitud === 'nuevo') {
        this.esNuevo = true;
        this.tiposolicitud = {
          codigo: null,
          titulo: 'Insert Title',
          subtitulo: 'Insert Description',
          imagen: '',
          tipoEntidadRelacionaria: '',
          categoriaUsuaria: '',
          creado: 'Sistema',
        };

        return;
      }
      this.subscripcion = this.tipoSolicitudService.getTipoSolicitudDetalle(this.codTipoSolicitud)
          .subscribe(data => {
            this.inicializarCampos(data);
          });
    });
  }

  ngOnDestroy() {
    if (this.subscripcion) {
      this.subscripcion.unsubscribe();
    }
  }

  validarCodigo() {
    this.errorCodigo = null;

    if (!this.tiposolicitud.codigo || this.tiposolicitud.codigo .length <= 0) {
      this.errorCodigo = 'El código debe tener al menos 1 caracter.';
      return false;
    }

    if ( this.tiposolicitud.codigo .length > 10) {
      this.errorCodigo = 'El código debe tener como máximo 10 caracteres.';
      return false;
    }

    if ( this.tiposolicitud.codigo  === 'nuevo') {
      this.errorCodigo = 'Código de Solicitud inválido.';
      return false;
    }

    return true;
  }

  crearTipoSolicitud() {
    if (!this.validarCodigo()) {
      return;
    }

    this.checkeandCodigo = true;

    // Check para ver que el codigo no esta usado
    this.tipoSolicitudService.getTipoSolicitudDetalle(this.codTipoSolicitud)
      .subscribe(res => {
        this.checkeandCodigo = false;
        // Si el codigo ya existe, no puedo crear un producto
        if (res !== null) {
          this.errorCodigo = 'El codigo de Solicitud ya existe.';
          return false;
        }
        this.tipoSolicitudService
            .crear(this.tiposolicitud)
            .then(tiposolicitud => {
              this.alertService.showGrowl({
                type: GrowlType.SUCCESS,
                body: 'REQUEST_TYPE_RETRIEVED',
              });
            });
      });
  }

  editarTitulo(nuevoTexto) {
    this.tiposolicitud.titulo = nuevoTexto;
    this.editarTipoSolicitud();
  }

  editarDescripcion(nuevoTexto) {
    this.tiposolicitud.subtitulo = nuevoTexto;
    this.editarTipoSolicitud();
  }

  editarTipoEntidadRelacionada(nuevoTexto) {
    this.tiposolicitud.tipoEntidadRelacionaria = nuevoTexto;
    this.editarTipoSolicitud();
  }

  editarCategoriaUsuaria(nuevoTexto) {
    this.tiposolicitud.categoriaUsuaria = nuevoTexto;
    this.editarTipoSolicitud();
  }

  /**
   * Actualiza la Imagen
   */
  editarImagen(nuevaImagen) {
    this.tiposolicitud.imagen = nuevaImagen.imagenBase64;
    this.editarTipoSolicitud();
  }

  private editarTipoSolicitud() {
    this.tipoSolicitudService.editar(this.tiposolicitud)
      .then(data => {
        this.inicializarCampos(data);
        this.alertService.showGrowl({
          type: GrowlType.SUCCESS,
          body: 'EDITADO_CORRECTAMENTE',
        });
        this.router.navigate(['/soc/tiposolicitud/', this.tiposolicitud.codigo ]);
      });
  }

  private inicializarCampos(data) {
    this.tiposolicitud = data;
    if (this.tiposolicitud.completitud) {
      this.tiposolicitud.completitud = JSON.parse(this.tiposolicitud.completitud);
    }
  };
}




// WEBPACK FOOTER //
// D:/a/1/s/BackOffice/SOC/SxSoc.ClientWeb/src/app/private/tiposolicitud/configurar.tiposolicitud.component.ts